export const summaryRows: string[] = [
  'Tomo 1 — Fundamentos de Minería y Recursos Minerales',
  'Tomo 2 — Geología Aplicada a la Minería',
  'Tomo 3 — Exploración y Evaluación de Recursos Minerales',
  'Tomo 4 — Métodos de Explotación Minera',
  'Tomo 5 — Procesamiento y Beneficio de Minerales',
  'Tomo 6 — Seguridad, Higiene y Gestión de Riesgos en Minería',
  'Tomo 7 — Gestión Ambiental y Sostenibilidad Minera',
  'Tomo 8 — Minería, Sociedad y Comunidades',
  'Tomo 9 — Enseñanza de la Minería: Estrategias, Actividades y Proyectos Educativos',
  'Bono 1 — 150 Actividades y Desafíos',
  'Bono 2 — Kit de Evaluación Completo',
  'Bono 3 — 100 Casos y Situaciones Problemáticas',
  'Bono 4 — Diccionario Docente de 200 Conceptos',
  'Bono 5 — 50 Proyectos Educativos',
  'Garantía de 7 días sin preguntas',
  'Acceso inmediato',
];
